import React, { FC, ReactElement } from 'react';

import RolloutValue from './RolloutValue';
import { ControlledInputPropsBase } from '@/common/InputControlProps';
import { RolloutTarget, VariableInfo } from '@/lib/App';
import RolloutDiffValueV2 from '@/pages/RolloutDifference/RolloutDiffViewer/RolloutDiffUtils/RolloutDiffValueV2';

interface DefaultRolloutBlockProps
  extends ControlledInputPropsBase<RolloutTarget> {
  variable: VariableInfo;
  disabled?: boolean;
  isDiff?: boolean;
  oldDefaultTarget?: RolloutTarget;
}

const DefaultRolloutBlock: FC<DefaultRolloutBlockProps> = ({
  onChange,
  value: rolloutSlice,
  variable,
  disabled,
  isDiff,
  oldDefaultTarget,
}) => {
  const { value, script, string } = rolloutSlice;

  function renderContent(): ReactElement {
    if (isDiff)
      return (
        <RolloutDiffValueV2
          baseTarget={oldDefaultTarget}
          compareTarget={rolloutSlice}
          variableType={variable.type}
        />
      );

    return (
      <RolloutValue
        value={{ value, script, string }}
        variable={variable}
        onChange={(val) => onChange({ ...rolloutSlice, ...val })}
        disabled={disabled}
      />
    );
  }

  return renderContent();
};

export default DefaultRolloutBlock;
